
export const GET_ORDER_PROVIDER = 'GET_ORDER_PROVIDER';
export const GET_ORDER_PROVIDER_SUCCESS = 'GET_ORDER_PROVIDER_SUCCESS';
export const GET_ORDER_PROVIDER_FAILED = 'GET_ORDER_PROVIDER_FAILED';
export const ADD_COMMENT_ORDER_PROVIDER = 'ADD_COMMENT_ORDER_PROVIDER';